<div class="target-group-container">
  <div class="employee-visibility-container">
    <app-employee-visibility
      [isCourse]="isCourse"
      [isPrivatePublishing]="isPrivatePublishing"
      
      [visibilityMode]="visibilityMode"
      (visibilityModeChange)="onVisibilityModeChanged($event)"

      [allowSharingWithSubscribers]="allowSharingWithSubscribers"
      (allowSharingWithSubscribersChange)="onAllowSharingWithSubscribersChanged($event)"

      [subscriptionIds]="subscriptionIds"
      (subscriptionIdsChange)="onSubscriptionIdsChanged($event)"

      [organizationUnitIds]="selectedOrganizationUnitIds"
      (organizationUnitIdsChange)="onOrganizationUnitIdsChanged($event)"

      [trainingGroupIds]="trainingGroupIds"
      (trainingGroupIdsChange)="onTrainingGroupIdsChanged($event)"

      [standardTrainingCategoryIds]="standardTrainingCategoryIds"
      (standardTrainingCategoryIdsChange)="onStandardTrainingCategoryIdsChanged($event)"

      [roleIds]="roleIds"
      (roleIdsChange)="onRoleIdsChanged($event)"

      [organizationUnits]="organizationUnits"
      [trainingGroups]="trainingGroups"
      [subscribers]="subscribers"
      [standardTrainingCategories]="standardTrainingCategories"
      [roles]="roles"
      [usedStandardTrainingCategories]="usedStandardTrainingCategories"
      [employeeCount]="personCount"
      [isViewMode]="isViewMode"
    ></app-employee-visibility>
  </div>
  <hr>
  <div class="catalogue-container">
    <app-catalogue-selector
      [isViewMode]="isViewMode"
      [trainingCategories]="trainingCategories"
      [trainingCategoryIds]="trainingCategoryIds"
      (trainingCategoryIdsChange)="onTrainingCategoryIdsChanged($event)"
    ></app-catalogue-selector>
</div>